import { render, staticRenderFns } from "./BtnToolbar.vue?vue&type=template&id=396455dc&"
import script from "./BtnToolbar.vue?vue&type=script&lang=js&"
export * from "./BtnToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports